import {SagaIterator} from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import {ContentActionsService} from '~commonInfra/contentActions/ContentActions';
import {SessionSiteSelectors} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { IPredictiveModelDetailInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { EditPredictiveModelReduxAction } from '../actions/EditPredictiveModelReduxAction';
import { getPredictiveModelDetailInfo } from '../PredictiveModelsSagaHelpers';

export function* handleEditPredictiveModel(action: EditPredictiveModelReduxAction): SagaIterator {
  const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
  let predictiveModel: IPredictiveModelDetailInfo;
  try {
    predictiveModel = yield call(getPredictiveModelDetailInfo, action.predictiveModel.id);
  } catch (e) {
    // TODO Should we launch a toast here?
    yield put(requestFailed(e, Messages.errorUnknown()));
    return;
  }

  ContentActionsService.editPredictiveModel(siteUrlName, predictiveModel.luid);
}
